import { ReactElement } from "react";
import WebGLIframe from "./WebGLIframe";
import { Android, IPad, Iphone, MacOS, MetaQuest, Pico, WebGL, Windows10, Scorm } from "./index";

interface Props {
  platform: string;
  iconProps?: any;
  inTable?: boolean;
  scormVersion?: string | null;
}

export default function PlatformIcon({
  platform,
  iconProps = { width: "50px", height: "50px", fill: "black", style: "mr-fix-important" },
  inTable = false,
  scormVersion = undefined,
}: Props): ReactElement {
  switch (platform) {
    case "OculusQuest":
      return (
        <MetaQuest {...iconProps} style={iconProps.style} width="90px" height={iconProps.height} />
      );
    case "PicoNeo":
      return <Pico {...iconProps} style={iconProps.style} width="50px" height={iconProps.height} />;
    case "Android":
      return (
        <Android
          {...iconProps}
          style={iconProps.style}
          width={iconProps.width}
          height={iconProps.height}
        />
      );
    case "iPhone":
    case "IPhone":
      return (
        <Iphone
          {...iconProps}
          style={iconProps.style}
          width={iconProps.width}
          height={iconProps.height}
        />
      );
    case "iPad":
    case "IPad":
      return (
        <IPad
          {...iconProps}
          style={iconProps.style}
          width={iconProps.width}
          height={iconProps.height}
        />
      );
    case "MacOS":
      return (
        <MacOS
          {...iconProps}
          style={iconProps.style}
          width={iconProps.width}
          height={iconProps.height}
        />
      );
    case "Windows10":
    case "Windows 64bit":
    case "Windows64bit":
    default:
      return (
        <Windows10
          {...iconProps}
          style={iconProps.style}
          width={iconProps.width}
          height={iconProps.height}
        />
      );
    case "WebGLApp_scorm":
      return <Scorm {...iconProps} style={iconProps.style} width={30} height={30} />;
    case "WebGLApp":
    case "WebGL App":
      if (scormVersion) {
        return <Scorm {...iconProps} style={iconProps.style} width={30} height={30} />;
      }
      return (
        <WebGL
          {...iconProps}
          style={iconProps.style}
          width={iconProps.width}
          height={iconProps.height}
        />
      );
    case "WebGLiframe":
    case "WebGL iframe":
      return (
        <WebGLIframe
          {...iconProps}
          style={iconProps.style}
          width={iconProps.width ?? 55}
          height={iconProps.height ?? 55}
          inTable={inTable}
        />
      );
  }
}
